module.exports = __webpack_public_path__ + "assets/img/Aerial View (Ulu Pandan Road).4bf7a590.jpg";